import ErrorBoundary from "@/components/shared/ErrorBoundary";
import MersalgTab from "@/components/project/MersalgTab";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";

export default function MersalgPage() {
  const { project, internalReadOnly } = useProjectDetailContext();
  return (
    <ErrorBoundary>
      <MersalgTab projectId={project.id} readOnly={internalReadOnly} />
    </ErrorBoundary>
  );
}
